import MasterICCardImportPage from './MasterICCardImportPage';

export default MasterICCardImportPage;